require( './bootstrap' );
$(document).ready(function(){
    $('#mobile-button').click(function () {
        $(this).toggleClass('active');
        $('#mobile-menu').toggleClass('show-menu');
    })

    let start_timer = document.getElementById('time');
    if (start_timer) {
        function writeTime() {
            let date = new Date();
            let minute = date.getMinutes();
            if (minute === 0) {
                minute = '00';
            } else if (minute < 10) {
                minute = '0' + date.getMinutes();
            }
            document.getElementById('time').innerHTML = date.getHours() + ':' + minute;
        }

        writeTime();

        setTimeout(writeTime, 500);
    }

});

// to top
function scrollTo(to, duration = 700) {
    const
      element = document.scrollingElement || document.documentElement,
      start = element.scrollTop,
      change = to - start,
      startDate = +new Date(),
      // t = current time
      // b = start value
      // c = change in value
      // d = duration
      easeInOutQuad = function (t, b, c, d) {
          t /= d / 2;
          if (t < 1) return c / 2 * t * t + b;
          t--;
          return -c / 2 * (t * (t - 2) - 1) + b;
      },
      animateScroll = function () {
          const currentDate = +new Date();
          const currentTime = currentDate - startDate;
          element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
          if (currentTime < duration) {
              requestAnimationFrame(animateScroll);
          } else {
              element.scrollTop = to;
          }
      };
    animateScroll();
}
document.addEventListener('DOMContentLoaded', function () {
    let btn = document.querySelector('#toTop');
    if (btn) {
        window.addEventListener('scroll', function () {
            // show if > 599px
            if (pageYOffset > 100) {
                btn.classList.add('show');
                // remove
            } else {
                btn.classList.remove('show');
            }
        });

        // to top on click
        btn.onclick = function (click) {
            click.preventDefault();
            scrollTo(0, 400);
        }
    }
});
